import { ReactElement } from 'react';
import {
    Datagrid,
    List,
    ListProps,
    TextField,
    EditButton,
    useListContext,
    CreateButton,
    FunctionField, useDataProvider, useNotify, useRefresh
} from 'react-admin';
import { Typography } from '@material-ui/core';
import Switch from '@mui/material/Switch';
import { Box } from '@mui/material';
import * as React from "react";

const Empty = () => {
    const { basePath, resource } = useListContext();
    return (
        <Box style={{ padding: 20 }} textAlign="center" m={1}>
            <Typography variant="h4" paragraph>
                No Servers available
            </Typography>
            <Typography variant="body1">
                Do you want to add one ?
            </Typography>
            <div style={{ padding: 10 }}></div>
            <CreateButton basePath={basePath} />
        </Box>
    );
};

const ResourceList = (props: ListProps): ReactElement => {

    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();

    const handleSubmit = (id: string, status: boolean) => {
        dataProvider.update(
            'servers/update',
            {
                id: id,
                data: {
                    server_status: status
                },
                previousData: {
                    id: id,
                }
            },
            {
                onSuccess: () => {
                    const timer: ReturnType<typeof setTimeout> = setTimeout(() => refresh(), 1000);
                    notify('Your Server was successfully updated', 'info');
                },
                onFailure: () => {
                    notify('Error: Your Server was not successfully updated', 'warning');
                }
            },
        )
    }


    return (
        <div style={{ paddingLeft: 25 }}>
            <List
                title="Servers"
                empty={<Empty />}
                {...props}
                perPage={25}
            >
                <Datagrid>
                    <TextField source='server_owner' />
                    <FunctionField
                        label="Countries"
                        render={(record: any) => `${record['server_country'].length <= 7 ? record['server_country'] : record['server_country'].slice(0, 7) + "..."}`}
                    />
                    <FunctionField
                        label="Server Address"
                        render={(record: any) => `${record['server_address'].length <= 7 ? record['server_address'] : record['server_address'].slice(0, 20) + "..."}`}
                    />
                    <FunctionField
                        label="Base URL"
                        render={(record: any) => `${record['base_url'].length <= 7 ? record['base_url'] : record['base_url'].slice(0, 20) + "..."}`}
                    />
                    <TextField source='connections_live' />
                    <FunctionField
                        label="Outrate Live Mbps"
                        render={(record: any) => `${Math.round(record['outrate_live'] / 1000000)}`}
                    />
                    <TextField source='server_status_info' label="Server health" />
                    <TextField source='rating' />
                    <FunctionField
                        label="Admin status"
                        render={(record: any) => {
                            return (
                                <Switch checked={record["server_status"]} color="success" onChange={(e) => handleSubmit(record['_id'], e.target.checked)} />
                            )
                        }}
                    />
                    <EditButton />
                </Datagrid>
            </List>
        </div>
    )
}

export default ResourceList;